export default __webpack_public_path__ + "static/media/homePageMainImage.915f489c.jpg";